import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => (
  <footer className="ctf-footer">
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12">
          <div className="ctf-footer-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className="ctf-footer-copyright" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
              <img
                className="ctf-footer-logo"
                src="resources/images/pyi-logo-home.png"
                alt="Powr of You logo"
              />
              <div className="ctf-footer-copy-text" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div>Copyright © 2014 - {new Date().getFullYear()}</div>
                <div>
                  Powr of You® Ltd. |{' '}
                  <Link className="ctf-footer-link" to="legal">
                    Privacy Policy
                  </Link>
                </div>
              </div>
            </div>
            <div className="ctf-footer-contacts-wrapper">
              <div className="ctf-footer-contacts" style={{ display: 'flex', gap: '40px', alignItems: 'center' }}>
                <div className="ctf-footer-contacts-item" style={{ margin: 0, textAlign: 'right' }}>
                  <b>United States</b>, San Francisco
                  <br />
                  <a className="ctf-footer-link" href="tel:+19254875326">
                    +1 925 478 5670
                  </a>
                </div>
                <div className="ctf-footer-contacts-item" style={{ margin: 0, textAlign: 'right' }}>
                  <b>United Kingdom</b>, London
                  <br />
                  <a className="ctf-footer-link" href="tel:+447449022218">
                    +44 74490 22218
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
)

export default Footer
